import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.scss';

const Memeism = lazy(() => import('./pages/Memeism'));

function App() {
  return (
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<Memeism />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
